import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from 'recharts'
import { ChartDataPoint } from '@/lib/api/dashboard/dashboard-api'

interface ClientsGrowthChartProps {
    data: ChartDataPoint[]
}

export default function ClientsGrowthChart({ data }: ClientsGrowthChartProps) {
    const total = data.reduce((sum, d) => sum + d.value, 0)

    return (
        <div className="bg-base-100 rounded-xl border border-base-300/50 p-5">
            <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-base-content">
                    Novos Clientes
                </h3>
                <div className="text-right">
                    <p className="text-xl font-bold text-secondary">{total}</p>
                    <p className="text-xs text-base-content/60">Total</p>
                </div>
            </div>

            {data.length === 0 ? (
                <div className="flex items-center justify-center h-48 text-base-content/50">
                    Sem dados
                </div>
            ) : (
                <div className="w-full" style={{ height: '180px', minHeight: '180px' }}>
                    <ResponsiveContainer width="100%" height={180}>
                        <AreaChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
                            <defs>
                                <linearGradient id="colorClients" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="5%" stopColor="#8b5cf6" stopOpacity={0.3} />
                                    <stop offset="95%" stopColor="#8b5cf6" stopOpacity={0} />
                                </linearGradient>
                            </defs>
                            <CartesianGrid strokeDasharray="3 3" className="opacity-30" />
                            <XAxis
                                dataKey="label"
                                tick={{ fontSize: 10 }}
                                tickLine={false}
                                axisLine={false}
                            />
                            <YAxis
                                tick={{ fontSize: 10 }}
                                tickLine={false}
                                axisLine={false}
                                allowDecimals={false}
                            />
                            <Tooltip
                                contentStyle={{
                                    backgroundColor: 'oklch(var(--b1))',
                                    border: '1px solid oklch(var(--b3))',
                                    borderRadius: '8px',
                                }}
                                formatter={(value) => [value ?? 0, 'Clientes']}
                            />
                            <Area
                                type="monotone"
                                dataKey="value"
                                stroke="#8b5cf6"
                                strokeWidth={2}
                                fillOpacity={1}
                                fill="url(#colorClients)"
                            />
                        </AreaChart>
                    </ResponsiveContainer>
                </div>
            )}
        </div>
    )
}
